import { render, staticRenderFns } from "./TransferPier.vue?vue&type=template&id=b2d0ee6a&"
import script from "./TransferPier.vue?vue&type=script&lang=js&"
export * from "./TransferPier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports